// extracted by mini-css-extract-plugin
module.exports = {"box":"Layout_box__33RCt","header":"Layout_header__3EItT","nav":"Layout_nav__e7Z21","selectedIcon":"Layout_selectedIcon__3L739","unselectedIcon":"Layout_unselectedIcon__3GXsf"};